import { Button, Dialog, Grid, TextField, Typography } from '@mui/material';
import { useState } from 'react';
import ConfirmationModal from 'src/content/common/confirmationModal/ConfirmationModal';
import { useAppSelector } from 'src/hooks/hooks';

interface Props {
    open: boolean,
    onClose: any,
    onSubmit?: any,
    getData: any
  }

const WfhRejectReasonForm = (props: Props) => {
  const { isLoading } = useAppSelector((state) => state.appReducer);
  const [openConfirmation, setOpenConfirmation] = useState(false);
  const [isDisableReject, setIsDisableReject] = useState(true);
  const [rejectReason, setRejectReason] = useState('');

  const validateConfirmation = () => {
    setOpenConfirmation(!openConfirmation);
  };

  const onRejectRequest = (reason: string) => {
    const sendData = {
        reason: rejectReason
      }
      props.getData(sendData)
      setOpenConfirmation(!openConfirmation);
  };

  const handleClose = () => {
    props.onClose();
  };

  const handleSubmit = () => {
    props.onSubmit();
  }

  const rejectBtnDisableStyle = { 
    backgroundColor: '#F8F2F2', 
    color: 'red',
    opacity: 0.4
  }

  const rejectBtnStyle = {
    backgroundColor: '#F8F2F2', 
    color: 'red'
  }

  return (
    <Dialog
      open={props.open}
      maxWidth="sm"
      fullWidth
      scroll="paper"
      onClose={handleClose}
      onSubmit={handleSubmit}
    >
      <form>
        <>
          <Grid
            item
            xs={12}
            style={{ marginTop: '2rem' }}
            sx={{ mt: 5, pb: 2, pl: 2 }}
          >
            <Typography sx={{}}>
              Reject Reason
              <span style={{ color: 'red', marginLeft: '3px' }}>*</span>
            </Typography>
          </Grid>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                size="small"
                multiline
                rows={4}
                className="input-text"
                style={{
                    paddingTop: 2,
                    paddingLeft: 15,
                    paddingRight: 15,
                    fontSize: '12px'
                }}
                inputProps={{
                  style: {
                    fontSize: '13px'
                  },
                  maxLength: 200
                }}
                fullWidth
                placeholder="Enter reject reason"
                variant="outlined"
                onChange={(e) => {
                    setRejectReason(e.target.value);
                    if(e.target.value.trim()){
                      setIsDisableReject(false);
                    } else {
                      setIsDisableReject(true);
                    }
                }}
              />
            </Grid>
          </Grid>
          <Grid
            item
            sx={{
              mb: 2,
              mt: 2,
              pr: 2,
              display: 'flex',
              justifyContent: 'flex-end'
            }}
          >
            <Button
              sx={{
                width: '100px',
                ml: 2,
                fontSize: '13px',
                fontWeight: 'normal',
                background: '#F5F7FF',
                color: '#5569ff'
              }}
              variant="contained"
              onClick={(e) => {
                handleClose();
              }}
            >
              Cancel
            </Button>
            <Button
              sx={{
                width: '100px',
                fontWeight: 'normal',
                background: '#F5F7FF',
                fontSize: '13px',
                ml: 2
              }}
                disabled={isDisableReject}
                style={isDisableReject ? rejectBtnDisableStyle : rejectBtnStyle}
                onClick={() => { validateConfirmation() }}
            >
              Reject
            </Button>
          </Grid>
          <ConfirmationModal
            isLoading={isLoading}
            open={openConfirmation}
            toggle={validateConfirmation}
            message={`Are you sure want to reject for this WFH request ?`}
            onConfirm={() => onRejectRequest(rejectReason)}
            noToggle={validateConfirmation}
          />
        </>
      </form>
    </Dialog>
  );
};

export default WfhRejectReasonForm;